import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../comman/form";
import auth from "../services/authService";
import { Link } from "react-router-dom";
import ForgetPassword from "./ForgetPassword";

class WorkflowLogin extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: { username: "", password: "" },
      errors: {},
      showHide: false,
      userTypes: [
        {
          id: 1,
          name: "Type 1",
        },
        {
          id: 2,
          name: "Type 2",
        },
      ],
    };
  }

  schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await auth.login(data.username, data.password);
      //console.log(this.props);
      if (this.props.location.state !== undefined) {
        window.location = this.props.location.state.from.pathname;
      } else {
        window.location = "/";
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data.message;
        this.setState({ errors });
      }
    }
  };

  handleModalShowHide = () => {
    this.setState({ showHide: !this.state.showHide });
  };

  render() {
    const { userTypes } = this.state;
    if (auth.getCurrentUser()) return <Link to="/" />;
    return (
      <div className="h-100 w-100 bg-default">
        <div style={{ backgroundColor: "#2e1a47", textAlign: "center" }}>
          <img
            src="/assets/Img/truistLogo.png"
            alt=""
            style={{
              objectFit: "contain",
              marginTop: "-1px",
              height: "90px",
            }}
          />
        </div>
        {/* Main content */}
        <div className="main-content bg-default">
          {/* Header */}
          <div className="header bg-white pt-4" style={{ paddingBottom: 250 }}>
            <div className="container">
              <div className="header-body text-center">
                <div className="row justify-content-center">
                  <div className="col-xl-12 col-lg-6 col-md-8 px-5">
                    <h3 className="text-black">
                      WORKFINITY*® NEXT GENERATION AUTOMATED GRANT MANAGEMENT
                      SYSTEM
                    </h3>
                    <h1 className="text-black mb-4">
                      GATEWAY ACCESS TO GOVERNMENT AGENCIES
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                x={0}
                y={0}
                viewBox="0 0 2560 100"
                preserveAspectRatio="none"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient id="LineChartGradient">
                    <stop offset="5%" stopColor="#172b4d" />
                    <stop offset="95%" stopColor="#1a174d" />
                  </linearGradient>
                </defs>
                <polygon fill="#172b4d" points="2560 0 2560 100 0 100" />
              </svg>
            </div>
          </div>
          {/* Page content */}
          <div className="container bg-default" style={{ marginTop: "-250px" }}>
            <div className="row d-flex justify-content-center">
              <div className="col-lg-5 col-md-7">
                <div
                  className="card border-0 mb-0 pt-1 pb-3"
                  style={{ backgroundColor: "" }}
                >
                  <div className="card-body px-lg-5 py-lg-5">
                    <div className="text-center text-white mb-2">
                      <h3 className="text-black">Sign In</h3>
                    </div>
                    {this.renderSelect(
                      "userType",
                      "Identify Yourself",
                      userTypes,
                      "name",
                      "id"
                    )}
                    {this.renderInput("username", "Username")}
                    {this.renderInput("password", "Password", "password")}
                    <div className="form-group mt--2">
                      <input
                        className="checkbox mr-2"
                        id=" customCheckLogin"
                        type="checkbox"
                      />
                      <label htmlFor="customCheckLogin">Remember me</label>
                      <button
                        className="btn btn-link btn-sm"
                        onClick={this.handleModalShowHide}
                        style={{ float: "right" }}
                      >
                        Forgot Password?
                      </button>

                      <ForgetPassword
                        showHide={this.state.showHide}
                        handleModalShowHide={this.handleModalShowHide}
                      ></ForgetPassword>
                    </div>
                    <div className="text-center mt-4">
                      <button
                        className="btn btn-outline-default"
                        disabled={this.validate()}
                        onClick={this.handleSubmit}
                      >
                        Sign in
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <p
                className="text-black mt-3"
                style={{
                  fontSize: 12,
                  lineHeight: 1.5,
                  fontWeight: 400,
                  color: "white",
                }}
              >
                Under US Patent Protection
                <br></br>
                This software is licensed to the user. Use of the software
                constitutes acceptance of the terms and conditions of the
                License Agreement.
                <br></br>
                ©IPCS®, ©WorkFinity® All rights reserved.
                <br></br>
                <img src="../../assets/img/logo_no_bg.png" height={20} />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WorkflowLogin;
